import { createBusinessComponent } from '../utils/create';
import '@tujia/fe-lib-common/lib/third-libs/date-helper.js';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_c('div', {
      staticClass: "day-content",
      class: _vm.dayClass,
      style: _vm.dayStyle,
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.$emit('click', _vm.day);
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "tj-fade"
      }
    }, [_vm.isYesterday ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isShowYesterdayTip,
        expression: "isShowYesterdayTip"
      }]
    }, [_c('i', {
      staticClass: "day-tip-arrows"
    }), _c('span', {
      staticClass: "day-tip",
      style: _vm.getYseterdayStyle
    }, [_vm._v("\n          " + _vm._s(_vm.yesterdayTip) + "\n        ")])]) : _vm._e()]), _vm.isYesterday && !_vm.day.isBegin ? _c('img', {
      staticClass: "day-moon",
      attrs: {
        "src": "https://pic.tujia.com/upload/festatic/publicImages/calendar_moon.png",
        "alt": "凌晨"
      }
    }) : _vm._e(), _c('em', {
      staticClass: "day-txt",
      class: {
        'isHolidayStyle': _vm.isHolidayStyle,
        'isWorkStyle': _vm.isWorkStyle
      }
    }, [_vm._v("\n      " + _vm._s(_vm.dayDescText) + "\n    ")]), _vm.day.date ? _c('strong', {
      class: {
        'z-specail-day': _vm.specailDayText,
        'z-specail-jrday': !!_vm.day.jrText,
        'isWeekend': (_vm.day.date && _vm.day.date.getDay() === 0 || _vm.day.date && _vm.day.date.getDay() === 6) && _vm.isCustomStyle,
        'isHolidayStyle': _vm.isHolidayStyle && _vm.isShowHoliday,
        'isWorkStyle': _vm.isWorkStyle
      },
      style: _vm.holidayStyle
    }, [_c('span', [_vm._v(_vm._s(_vm.dayText))])]) : _vm._e(), _vm.dayDescPrice ? _c('em', {
      staticClass: "price-txt"
    }, [_vm._v("\n      " + _vm._s(_vm.dayDescPrice) + "\n    ")]) : _vm._e()], 1)]);
  },
  name: 'calendar-day',
  props: {
    day: {
      type: Object // default:{
      //   date:new Date(),
      //   isBegin:false,
      //   isDuring:false,
      //   isEnd:false,
      //   isUnActiveDay:false //是否过期，代表该时间已经过去了
      //   customText:'' //自定义显示文本
      // }

    },
    isShowYesterdayTip: {
      type: Boolean,
      default: false
    },
    isPriceCalendar: {
      type: Boolean,
      value: false
    },
    dateText: {
      type: Object // default: {
      //   begin: '',
      //   end: ''
      // }

    },
    isCustomStyle: {
      type: Boolean,
      default: false
    },
    isShowHoliday: {
      type: Boolean,
      default: false
    },
    // 班休数据
    holidayData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isOver: false
    };
  },
  computed: {
    specailDayText: function specailDayText() {
      var date = this.day.date;

      if (!date) {
        return '';
      }

      if (this.isToday && this.day.isEnd) {
        return '中午';
      } else if (this.isToday) {
        return '今天';
      } else if (this.isTomorrow) {
        return '明天';
      } else if (this.day.jrText && !this.isShowHoliday) {
        return this.day.jrText;
      } else {
        return '';
      }
    },
    dayText: function dayText() {
      if (this.isYesterday) {
        return '凌晨';
      } else if (this.specailDayText) {
        return this.specailDayText;
      } else {
        return this.day.date.getDate();
      }
    },
    dayDescText: function dayDescText() {
      var _this$day, _this$day2;

      if (this.day.isBegin) {
        return this.dateText.begin || '入住';
      } else if (this.day.isEnd) {
        return this.dateText.end || '离店';
      } else if (!this.day.isUnActiveDay && !this.day.isBlankSpace && this.day.customText) {
        return this.day.customText;
      } else if ((_this$day = this.day) != null && _this$day.jrText && this.isShowHoliday) {
        return this.day.jrText;
      } else if ((_this$day2 = this.day) != null && _this$day2.date && this.isShowHoliday) {
        var _this$holidayData;

        var thisYear = this.day.date.getFullYear();
        var thisMonth = this.day.date.getMonth() + 1 >= 10 ? this.day.date.getMonth() + 1 : '0' + (this.day.date.getMonth() + 1);
        var thisDay = this.day.date.getDate() >= 10 ? this.day.date.getDate() : '0' + this.day.date.getDate();
        var thisDate = thisYear + '-' + thisMonth + '-' + thisDay;
        var thisHoliday = [];
        thisHoliday = (_this$holidayData = this.holidayData) == null ? void 0 : _this$holidayData.filter(function (item) {
          return item.holidayDate === thisDate;
        });

        if (thisHoliday && thisHoliday[0] && thisHoliday[0].reset) {
          return thisHoliday[0].reset;
        }
      } else if (this.day.isShortCustom && this.day.customText) {
        // if (!this.day.isUnActiveDay && this.day.isBlankSpace) {}
        return this.day.customText;
      } else {
        return '';
      }
    },
    isHolidayStyle: function isHolidayStyle() {
      var _this$day3;

      if (this.day.isShortCustom && this.day.isBlankSpace) {
        return false;
      }

      if (this.dayDescText === '休' || !!((_this$day3 = this.day) != null && _this$day3.jrText)) {
        return true;
      }
    },
    isWorkStyle: function isWorkStyle() {
      if (this.dayDescText === '班') {
        return true;
      }
    },
    dayDescPrice: function dayDescPrice() {
      if (!this.day.isUnActiveDay && !this.day.isBlankSpace) {
        if (this.day.isBooking) {
          return this.day.bookPrice > 0 ? "\xA5" + this.day.bookPrice : '';
        }

        return '无房';
      } else {
        return 0;
      }
    },
    isYesterday: function isYesterday() {
      return this.day.isYesterday;
    },
    yesterdayTip: function yesterdayTip() {
      return this.day.yesterdayTip;
    },
    isToday: function isToday() {
      return this.day.date && this.day.date.isToday();
    },
    isTomorrow: function isTomorrow() {
      return this.day.date && this.day.date.isToday(new Date().addDays(1));
    },
    // 设置yseterday tip 的浮动位置
    // TODO 该提示暂时无法兼容 短提示
    getYseterdayStyle: function getYseterdayStyle() {
      var week = this.day.date.getDay();

      switch (week) {
        case 0: // 周日

        case 1: // 周一

        case 2:
          // 周二
          return {
            left: '0'
          };

        case 3:
          return {
            right: '-100px'
          };

        case 4:
        case 5:
        case 6:
          return {
            right: '0'
          };

        default:
      }
    },
    dayStyle: function dayStyle() {
      var style = this.day.style;
      var styles = ''; // 日期不可用 且 该日期无自定义样式

      if (this.day.isUnActiveDay || !style || !Object.keys(style).length) {
        return {};
      } else {
        // style.disabled 为逻辑属性，为真时表示该日期被已被原有样式覆盖，不再使用自定义样式
        if (style.disabled) {
          return {};
        } // 开始日期、结束日期的区间样式


        if (this.day.isDuring) {
          styles = style.middle;
        } // 未选中时默认样式


        if (!this.day.isBegin && !this.day.isEnd && !this.day.isDuring) {
          styles = style.default;
        }

        ; // 开始日期、结束日期样式

        if ((this.day.isBegin || this.day.isEnd) && !this.day.isDuring) {
          styles = style.active;
        }

        ; // 自定义style

        if (this.day.isShortCustom && style.custom) {
          styles = style.custom;
        }

        ;
        return styles;
      }
    },
    holidayStyle: function holidayStyle() {
      if (this.day.style) {
        if (this.day.style.disabled || this.day.isBegin || this.day.isEnd) return {
          color: ''
        };
        if (this.day.style.holiday && this.specailDayText) return this.day.style.holiday;
      }
    },
    dayClass: function dayClass() {
      return {
        'z-day-selected-begin': this.day.isBegin,
        'z-day-selected-end': this.day.isEnd,
        'z-day-selected-during': this.day.isDuring,
        'z-day-unactive': this.day.isUnActiveDay,
        'z-day-blank-space': this.day.isBlankSpace,
        // 当日期是选中的结束日期，或者可选状态 或者非房 则不显示不可预订状态
        'z-un-booking': !this.day.isEnd && !this.day.isSelectable && !this.day.isUnActiveDay && !this.day.isBlankSpace && !this.day.isBooking,
        // 当日期是选中的结束日期，则不显示不可选状态
        'z-un-selectable': !this.day.isEnd && !this.day.isSelectable && !this.day.isBooking,
        // 当前日期有价格且可以预定
        'z-day-booking-price': !this.day.isEnd && !this.day.isSelectable && !this.day.isUnActiveDay && !this.day.isBlankSpace && this.day.bookPrice && this.day.isBooking,
        // 当前日期有价格但不能预订，无房
        'z-day-un-booking-price': !this.day.isEnd && !this.day.isSelectable && !this.day.isUnActiveDay && !this.day.isBlankSpace && this.day.bookPrice && !this.day.isBooking
      };
    }
  }
});